export type Post = {
  id: string;
  databaseId?: number;
  ownerId?: number;
  title: string;
  description: string;
  owner: string;
  initials: string;
  accountType: "Single" | "Couple";
  location: string;
  distance: string;
  category: string;
  posterType: string;
  seeking: string[];
  freshness: string;
  accent?: "fresh" | "warm" | "purple";
};

export type MeetupDate = {
  id: string;
  day: string;
  month: string;
  weekday: string;
  time: string;
  title: string;
  location: string;
  places: string;
  status: "Open" | "Almost full" | "Invitation only";
  description?: string;
};

export const posts: Post[] = [
  {
    id: "south-bank-drinks",
    title: "A late drink, good conversation, no pressure",
    description:
      "Finishing dinner near South Bank and seeing who else wants to keep the evening going.",
    owner: "Maya",
    initials: "MA",
    accountType: "Single",
    location: "South Brisbane",
    distance: "2.4 km",
    category: "Meet tonight",
    posterType: "Woman",
    seeking: ["Man", "Couple"],
    freshness: "12 min ago",
    accent: "warm",
  },
  {
    id: "west-end-weekend",
    title: "West End markets, then somewhere quieter",
    description:
      "Local couple with a free Saturday. Coffee first, and we can decide what feels right from there.",
    owner: "Lena & Ash",
    initials: "L+A",
    accountType: "Couple",
    location: "West End",
    distance: "3.1 km",
    category: "This weekend",
    posterType: "Couple",
    seeking: ["Woman", "Man", "Couple"],
    freshness: "38 min ago",
    accent: "purple",
  },
  {
    id: "new-farm-show",
    title: "One spare ticket for a small live show",
    description:
      "The friend I planned with cannot make it. Looking for easy company who genuinely enjoys live music.",
    owner: "Jordan",
    initials: "JO",
    accountType: "Single",
    location: "New Farm",
    distance: "4.7 km",
    category: "Events",
    posterType: "Non-binary",
    seeking: ["Any"],
    freshness: "1 hr ago",
    accent: "fresh",
  },
];

export const dates: MeetupDate[] = [
  {
    id: "july-rooftop",
    day: "18",
    month: "Jul",
    weekday: "Saturday",
    time: "7:30 pm",
    title: "Rooftop drinks before the city wakes up",
    location: "Fortitude Valley · venue shared after acceptance",
    places: "2 places remaining",
    status: "Open",
  },
  {
    id: "july-dinner",
    day: "24",
    month: "Jul",
    weekday: "Friday",
    time: "6:45 pm",
    title: "Small-table dinner with new company",
    location: "Brisbane City · exact venue shown",
    places: "1 place remaining",
    status: "Almost full",
  },
  {
    id: "august-coast",
    day: "02",
    month: "Aug",
    weekday: "Sunday",
    time: "10:00 am",
    title: "A slow drive down the coast",
    location: "Meeting point shared privately",
    places: "Invitation only",
    status: "Invitation only",
  },
];
